import BaseService from "@/boot/BaseService";
class MaquinaService extends BaseService {
    constructor() {
        super(null, "/maquinas");
    }
    async index(query) {
        return await this.get("/", {query});
    }

}

export default new MaquinaService();
